import { getReferrerOrigin } from "./referrerOrigin";

export const SHARE_REFERRER_PARAMETER = "_rp_referrer";

interface ShareVisitReferrer {
  pageUrl: string;
  referrer: string;
}

let pendingShareVisitReferrer: ShareVisitReferrer | null = null;

/** Consume the redirect parameter before the router and analytics SDKs read the URL. */
export function captureShareVisitReferrer(
  browser: Pick<Window, "location" | "history"> = window,
): void {
  pendingShareVisitReferrer = null;
  try {
    const landingUrl = new URL(browser.location.href);
    if (!/^\/product-share\/[A-Za-z0-9_-]{1,128}\/?$/.test(landingUrl.pathname)
      || /^\/product-share\/dev-preview\/?$/.test(landingUrl.pathname)) return;
    const forwardedReferrer = landingUrl.searchParams.get(SHARE_REFERRER_PARAMETER);
    if (forwardedReferrer === null) return;

    landingUrl.searchParams.delete(SHARE_REFERRER_PARAMETER);
    browser.history.replaceState(browser.history.state, "", landingUrl.href);
    landingUrl.hash = "";
    const referrerOrigin = getReferrerOrigin(forwardedReferrer);
    if (forwardedReferrer !== "" && !referrerOrigin) return;
    // An empty value explicitly preserves a missing referrer instead of crediting our wrapper.
    pendingShareVisitReferrer = { pageUrl: landingUrl.href, referrer: referrerOrigin };
  } catch {
    // Attribution must never prevent the page from loading.
  }
}

export function consumeShareVisitReferrer(pageUrl: string, browserReferrer: string): string {
  const landingReferrer = pendingShareVisitReferrer;
  pendingShareVisitReferrer = null;
  return landingReferrer?.pageUrl === pageUrl ? landingReferrer.referrer : browserReferrer;
}
